import { Fragment, useMemo } from 'react';
import { capitalize } from '@datassential/platform-ui-lib';
import cn from 'classnames';
import { highlightMatches } from '@core/helpers';
import { InstantChart, SubCategory } from './useInstantChartsData';
import { makeEnding } from "@core/old_helpers";

interface KeywordsListProps {
    chart: InstantChart;
    subCategory: SubCategory;
    matchedKeywords?: Set<string>;
    searchValue: string;
}

const KeywordsList = ({
    chart,
    subCategory,
    matchedKeywords,
    searchValue,
}: KeywordsListProps) => {
    const keywords = useMemo(
        () => {
            return (chart.keywords ?? []).sort((a, b) => {
                const aMatches = matchedKeywords?.has(a ?? '') ? 1 : 0;
                const bMatches = matchedKeywords?.has(b ?? '') ? 1 : 0;
                return bMatches - aMatches;
            });
        },
        [chart.keywords, matchedKeywords]
    );

    return (
        <div className="InstantCharts__keywords appears-top">
            <div className="InstantCharts__keywords-header">
                {capitalize(subCategory.name ?? '')}: {capitalize(chart.name ?? '')}
            </div>
            {chart.wordsCount && (
                <div className="InstantCharts__keywords-label">
                    {makeEnding('Keyword', chart.wordsCount)}:
                </div>
            )}
            <div className="InstantCharts__keywords-text">
                {keywords.map((keyword, index) => {
                    const text = keyword ?? '';
                    return (
                        <Fragment key={index}>
                            {index > 0 && ', '}
                            <span
                                className={cn({
                                    'InstantCharts__keyword--matched': matchedKeywords?.has(text),
                                })}
                                dangerouslySetInnerHTML={{
                                    __html: highlightMatches(capitalize(text), searchValue),
                                }}
                            />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default KeywordsList;
